export default {
  step1: '基本信息',
  step2: '产品属性',
  step3: '规格/价格信息',
  step4: '产品详情',
  productName: '产品名称',
  productNameRequired: '请输入产品名称',
  productNamePlaceholder: '请输入产品名称',
  productCategory: '产品分类',
  productNo: '产品编码',
  productNoRequired: '请输入产品编码',
  productNoPlaceholder: '请输入产品编码',
  productImage: '产品图片',
  productVideo: '产品视频',
  videoCover: '视频封面',
  videoCoverUpload: '视频封面',
  productWeight: '产品重量',
  weightPlaceholder: '请输入产品重量',
  weightUnit: 'kg',
  productUnit: '产品单位',
  unitPlaceholder: '请输入产品单位',
  productBarcode: '产品条形码',
  barcodePlaceholder: '请输入产品条形码',
  productRetailPrice: '产品零售价',
  retailPricePlaceholder: '请输入产品零售价',
  productMarketPrice: '产品市场价',
  marketPricePlaceholder: '请输入产品市场价',
  productAttributes: '产品属性：',
  attrGroup: '属性组',
  attrValue: '属性值',
  action: '操作',
  attrSelectPlaceholder: '请先选择属性',
  addAttr: '+ 增加一个',
  productSpec: '产品规格',
  singleSpec: '单规格',
  multiSpec: '多规格',
  productPrice: '产品价格',
  priceRequired: '请输入产品价格',
  pricePlaceholder: '请输入产品价格',
  priceUnit: 'USD',
  specNamePlaceholder: '规格名',
  specValuePlaceholder: '规格值',
  addSpecValue: '+ 添加',
  addSpec: '+ 添加规格',
  generateSpec: '+ 生成规格',
  applySpecChanges: '修改规格名称',
  specImage: '规格图片',
  specPrice: '价格(元)',
  specWeight: '产品重量',
  specVirtualSales: '虚拟销量',
  specNo: '规格编号',
  specNoPlaceholder: '商品编号',
  specNoRequired: '规格编号不能为空',
  specImageRequired: '规格图片不能为空',
  specMatrixRequired: '请先生成规格矩阵',
  select: '选择',
  productDetail: '产品详情',
  detailPlaceholder: '请输入正文',
  detailRequired: '请输入产品详情',
  phonePreview: '产品详情',
};
